export default "__VITE_ASSET__RCKjmVWX__"